import { render } from "./projectcase.vue?vue&type=template&id=7f1b0572&ts=true"
import script from "./projectcase.vue?vue&type=script&lang=ts"
export * from "./projectcase.vue?vue&type=script&lang=ts"

import "./projectcase.vue?vue&type=style&index=0&id=7f1b0572&lang=less"

import exportComponent from "E:\\dyy\\备份\\百廿官网\\bnkjgw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__